export const RANKING_ENDPOINTS = {
  MY_SCORES:
    '/api/v2/rankings/me',

  MY_STORE_SCORE: (
    storeId: number,
  ) =>
    `/api/v2/rankings/me/stores/${storeId}`,

  STORE_RANKING: (
    storeId: number,
  ) =>
    `/api/v2/rankings/stores/${storeId}`,

  ADMIN: {
    USER_SCORES: (
      userId: string,
    ) =>
      `/api/v2/admin/users/${userId}/scores`,
  },
} as const;